/* projects/speaker-platform/src/app/pages/admin/parameter-admin/parameter-admin.component.scss */
.editparameters__recorddays {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1607843137);
  border-radius: 10px;
}
.editparameters__recorddays__day {
  text-align: center;
}
/*# sourceMappingURL=parameter-admin.component-ZVVPZ7DE.css.map */
